import { render, staticRenderFns } from "./DiscoveryJobs.vue?vue&type=template&id=5a1e5eb8&scoped=true&"
import script from "./DiscoveryJobs.vue?vue&type=script&lang=js&"
export * from "./DiscoveryJobs.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryJobs.vue?vue&type=style&index=0&id=5a1e5eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e5eb8",
  null
  
)

export default component.exports